import type { Value, PointTarget, EdgeTarget, GeometryElementDisplayConfig } from '../../../geometrypad.model';

// =============================================================================
// TYPES
// =============================================================================

export interface RhombusElement {
  type: 'Rhombus';
  params: {
    s?: Value;
    angle?: Value;
    A?: PointTarget;
    B?: PointTarget;
    C?: PointTarget;
    D?: PointTarget;
    bottom?: EdgeTarget;
    right?: EdgeTarget;
    top?: EdgeTarget;
    left?: EdgeTarget;
  };
  names?: { s?: string; angle?: string; h?: string; d1?: string; d2?: string };
}

// =============================================================================
// STRUCTURAL CONSTANTS
// =============================================================================

export const RHOMBUS_EDGE_NAMES: readonly string[] = ['bottom', 'right', 'top', 'left'] as const;
export const RHOMBUS_PROPERTY_FOR_EDGE: Record<string, 's'> = { bottom: 's', right: 's', top: 's', left: 's' };

// =============================================================================
// DISPLAY DEFAULTS
// =============================================================================

/**
 * Default display theme for rhombus.
 *
 * Edge colors: bottom=sky, right=pink, top=purple, left=teal
 * Angle colors: alpha=sky, beta=pink, gamma=purple, delta=teal
 */
export const RHOMBUS_DEFAULTS: GeometryElementDisplayConfig = {
  polygon: { fillColor: 'sky', fillOpacity: 0.1 },
  line: { strokeWidth: 2, color: 'neutral' },
  angle: { fillOpacity: 0.2, radius: 0.8 },
  point: { visible: false, size: 3 },
  subparts: {
    bottom: { line: { color: 'sky' } },
    right: { line: { color: 'pink' } },
    top: { line: { color: 'purple' } },
    left: { line: { color: 'teal' } },
    // Angles
    alpha: { angle: { fillColor: 'sky', strokeColor: 'sky', visible: true } },
    beta: { angle: { fillColor: 'pink', strokeColor: 'pink', visible: true } },
    gamma: { angle: { fillColor: 'purple', strokeColor: 'purple', visible: true } },
    delta: { angle: { fillColor: 'teal', strokeColor: 'teal', visible: true } },
    // Points
    A: { point: { color: 'sky' } },
    B: { point: { color: 'pink' } },
    C: { point: { color: 'purple' } },
    D: { point: { color: 'teal' } },
  },
};
